import React from 'react'
import PropTypes from 'prop-types'

import "app/static/stylus/inline-custom-fields.styl"

const InlineCustomFields = props => (
    props.customFields && props.customFields.length
        ? (
            <div className="inline-custom-fields">
                {
                    props.customFields.map(tag => (
                        <div key={`${tag.title}|${tag.value}`} className="label label-primary">
                            <b>{tag.title}</b>: {tag.value}
                        </div>
                    ))
                }
            </div>
        )
        : null
)

InlineCustomFields.propTypes = {
    customFields: PropTypes.arrayOf(PropTypes.object),
}

export default InlineCustomFields
